import React from 'react';
import { useGlobal, getGlobal } from 'reactn';
import Card from '../../common/card/Card';
import Button from '../../common/button/Button';
import autoPay from '../../assets/auto-pay.png';
import autoPayDocument from '../../assets/documents/AUTO_PAY_FORM.pdf';

const AutoPay = ({ ...rest }) => {
  const { siteDetails } = getGlobal();
  const [serviceAccounts] = useGlobal('serviceAccounts');
  const [selectedServiceAccountIndex] = useGlobal(
    'selectedServiceAccountIndex'
  );

  const selectedServiceAccount = serviceAccounts[selectedServiceAccountIndex];

  if (selectedServiceAccount === undefined) {
    return <h4>SERVICE ACCOUNT UNAVAILABLE</h4>;
  }

  const { AUTO_PAY } = selectedServiceAccount.data;

  return (
    <Card
      title="Auto Payment"
      titleClassName="text-center"
      backgroundClass="bg-blue-dark flex flex-col h-1/4"
      {...rest}
    >
      <p className="text-bold text-center text-white my-auto">
        Looking to set up Auto Payment?
      </p>
      <div className="flex flex-col justify-end">
        {!AUTO_PAY ? (
          <Button
            iconUrl={autoPay}
            href={autoPayDocument}
            target="_blank"
            rel="noopener noreferrer"
            // secondary
          >
            Setup Automatic Bill Pay
          </Button>
        ) : (
          <Button
            iconUrl={autoPay}
            href={siteDetails.mcwa_automatic_bill_pay_url}
            target="_blank"
            rel="noopener noreferrer"
            // secondary
            shouldBtnDisable={AUTO_PAY}
            // className="w-full"
          >
            You are setup for Automatic Bill Pay
          </Button>
        )}
      </div>
    </Card>
  );
};

export default AutoPay;
